<template>
  <vs-row class="flex w-auto mr-4" vs-align="center" :class="size==='mobile' ? 'mobile layout-mobile' : ''">
    <vs-col class="w-auto mr-4">{{ label }}</vs-col>
    <vs-col class="w-auto">
      <vs-select autocomplete :class="size" v-model="select" @change="change">
        <vs-select-item
          v-for="(item, index) in list" :key="index"
          :text="item.text"
          :value="item.value"/>
      </vs-select>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  name: 'SearchNavItemSelect',
  props: {
    label: String,
    value: [Number, String],
    list: Array,
    size: {
      type: String,
      default: 'normal'
    }
  },
  watch: {
    value (value) {
      this.select = value
    }
  },
  data () {
    return {
      select: ''
    }
  },
  created () {
    this.select = this.value
  },
  methods: {
    change (data) {
      this.$emit('input', data)
      this.$emit('change', data)
    }
  }
}
</script>

<style scoped>

.layout-mobile {
  display: grid !important;
  grid-template-columns: 70px 1fr;
  margin:0 0 1rem 0 !important;
}
.mobile {
  width: 100% !important
}

.small {
  width: 100px;
}

.normal {
  width: 130px;
}

.big {
  width: 160px;
}

.auto {
  width: auto;
}
</style>
